import { CheckSvg, TimesSvg } from '@/assets/icons';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  gap: 4px;

  > svg:first-child {
    margin-top: 0.3em;
  }
`;

const CheckItem = ({ value, label }) => {
  return (
    <Wrapper>
      {value ? <CheckSvg color="#52c41a" /> : <TimesSvg color="#ff4d4f" width="14" />}
      {label}
    </Wrapper>
  );
};
export default CheckItem;
